import { useState } from "react";
import { useApi } from "../../utils/api/useApi";
import { SignupUserDto } from "../../models/signupUserDto";
import { signupEndpoint } from "../../utils/api/urls";

export const useSubmitUser = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { patch } = useApi<void>();

  const submitUser = async (signupUser: SignupUserDto) => {
    setLoading(true);
    setError(null);
    try {
      await patch(
        signupEndpoint,
        {
          Email: signupUser.email,
          Firstname: signupUser.firstname,
          Lastname: signupUser.lastname,
          Country: signupUser.country,
          State: signupUser.state,
          Password: signupUser.password,
          PhoneNumber: signupUser.phoneNumber,
          Language: signupUser.language
        },
        {
          headers: {
            "X-Kamstrup-WorkflowId": signupUser.workflowId
          }
        }
      );
    } catch (err: any) {
      const responseData = err.response?.data as ProblemDetails;
      if (responseData?.errors) {
        throw responseData.errors as BackendErrorDetail[];
      }
      throw [{ code: "workflow_missing_error", message: err.message || "Unknown error" }];
    } finally {
      setLoading(false);
    }
  };

  return { submitUser, loading, error };
};
